export const dndItemTypes = {
	sign: 'sign',
};
